import { makeStyles } from '@material-ui/core';

export const useSidebarStyles = makeStyles({
  logo: {
    width: '100%',
    height: '80px',
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '8px auto'
  },
  link: {
    fontSize: '0.75rem',
    fontWeight: 600,
    color: 'var(--bui-white)',
  },
  sidebarCollapseBtn: {
    padding: '0px !important',
    minWidth: '30px',
  },
  sidebarNavItemUser: {
    color: 'var(--bui-white)'
  },
  expandButtonWrapper: {
    display: 'flex !important',
    '& > *': {
      display: 'flex !important',
      visibility: 'visible !important',
      opacity: '1 !important',
    },
    '& button': {
      display: 'flex !important',
      visibility: 'visible !important',
      opacity: '1 !important',
    },
    // Override media query hiding
    '@media (max-width: 960px)': {
      display: 'flex !important',
      '& > *': {
        display: 'flex !important',
      },
      '& button': {
        display: 'flex !important',
      },
    },
  },
});